import type { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    path: '/pointsMall/:rest*',
    redirect: (to) => {
      return `/mini${to.fullPath}`;
    }
  },
  {
    path: '/mini/pointsMall',
    name: 'PointsMall',
    component: () => import('@/views/pointsMall/index.vue'),
    children: [
      {
        path: '',
        name: 'pointsMallHome',
        component: () => import('@/views/pointsMall/home.vue'),
        meta: {
          title: '积分商城',
          keepAlive: true,
          immersionPage: true,
          pageInfo: {
            PageID: 10307,
            PageName: '积分商城页'
          }
        }
      },
      {
        path: 'task',
        name: 'pointsMallTask',
        component: () => import('@/views/pointsMall/task.vue'),
        meta: {
          title: '积分任务',
          keepAlive: true,
          immersionPage: true,
          pageInfo: {
            PageID: 10310,
            PageName: '积分任务页'
          }
        }
      },
      {
        path: 'productDetail',
        name: 'pointsMallProductDetail',
        component: () => import('@/views/pointsMall/productDetail.vue'),
        meta: {
          title: '商品详情',
          immersionPage: true,
          pageInfo: {
            PageID: 10308,
            PageName: '积分商城商品详情页'
          }
        }
      },
      {
        path: 'confirmOrder',
        name: 'pointsMallConfirmOrder',
        component: () => import('@/views/pointsMall/confirmOrder.vue'),
        meta: {
          title: '确认订单'
        }
      },
      {
        path: 'exchangeRecords',
        name: 'pointsMallExchangeRecords',
        component: () => import('@/views/pointsMall/exchangeRecords.vue'),
        meta: {
          title: '兑换记录',
          keepAlive: true,
          pageInfo: {
            PageID: 10309,
            PageName: '积分商城兑换记录页'
          }
        }
      },
      {
        path: 'mine',
        name: 'pointsMallMine',
        component: () => import('@/views/pointsMall/mine.vue'),
        meta: {
          title: '个人中心',
          keepAlive: true,
          pageInfo: {
            PageID: 10309.1,
            PageName: '积分商城个人中心页'
          }
        }
      },
      {
        path: 'dailySignin',
        name: 'pointsMallDailySignin',
        component: () => import('@/views/pointsMall/dailySignin.vue'),
        meta: {
          title: '每日签到',
          keepAlive: true,
          immersionPage: true,
          pageInfo: {
            PageID: 10305,
            PageName: '签到页'
          }
        }
      },
      {
        path: 'rank',
        name: 'pointsMallRank',
        component: () => import('@/views/pointsMall/rank.vue'),
        meta: {
          title: '积分排行榜',
          immersionPage: true,
          pageInfo: {
            PageID: 10311,
            PageName: '积分排行榜页'
          }
        }
      }
    ]
  },
  {
    path: '/mini',
    name: 'miniProgram',
    children: [
      {
        path: 'game/qsdj3/gifts',
        name: 'qsdj3_Gifts',
        component: () => import('@/views/games/qsdj/gifts.vue'),
        meta: {
          title: '见面礼',
          keepAlive: true,
          pageInfo: {
            PageID: 10304.1,
            PageName: '枪神对决见面礼页'
          }
        }
      },
      {
        path: 'game/xkm4/gift',
        name: 'xkm4_Gifts',
        component: () => import('@/views/games/xkm4/gifts.vue'),
        meta: {
          title: '见面礼',
          keepAlive: true,
          pageInfo: {
            PageID: 10304,
            PageName: '见面礼页'
          }
        }
      }
    ]
  },
  {
    path: '/mini/content_activity/:id',
    name: 'content_activity',
    component: () => import('@/views/h5/contentActivity/index.vue')
  }
];

export default routes;
